import React from 'react'
import { privacy, terms, websiteUrl } from '../constants'

export default function PublicPageFooter() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="qpFooterSection">
            <div className="qpStoreButtonsFooter">
                <a
                    href="https://apps.apple.com/us/app/kimbocorp/id6737228466"
                    target="_blank"
                >
                    <img src="assets/img/landingPage/applestore.svg" alt="" />
                </a>
                <a
                    href="https://play.google.com/store/apps/details?id=io.kimbocorp"
                    target="_blank"
                >
                    <img src="assets/img/landingPage/playstore.svg" alt="" />
                </a>
            </div>
            <div className="container qpFooterInner">
                <p>
                    Copyright © {currentYear} kimbocorp Pte Ltd
                </p>
                <div className="qpFooterLinks">
                    <p onClick={() => window.open(terms)} className="m-0">Terms & conditions</p>
                    <p onClick={() => window.open(privacy)} className="m-0">Privacy policy</p>
                </div>
            </div>

        </div>

    )
}
